import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import styles from "./HomeBelowCards.module.scss";

const HomeBelowCards = ({ title, description, bgImage, reverseOrder }) => {
  console.log(bgImage);
  return (
    <div className={styles.heroContainer}>
      {/* Conditional rendering based on reverseOrder prop */}
      {reverseOrder ? (
        <>
          <div className={styles.imageContainer}>
            <img src={bgImage} alt={title} className={styles.image} />
          </div>
          <div className={styles.content}>
            <h1 className={styles.heading}>{title}</h1>
            <p className={styles.description}>{description}</p>
          </div>
        </>
      ) : (
        <>
          <div className={styles.content}>
            <h1 className={styles.heading}>{title}</h1>
            <p className={styles.description}>{description}</p>
          </div>
          <div className={styles.imageContainer}>
            <img src={bgImage} alt={title} className={styles.image} />
          </div>
        </>
      )}
    </div>
  );
};

export default HomeBelowCards;
